import saveReusableSectionButton from '../editor-buttons/SaveReusableSectionButton'

export default class DefaultConfig
{
    get() {
        return {
            plugins: _.join(this.plugins(), ' '),
            toolbar: _.join(this.toolbar(), ' | '),
            menubar: _.join(this.menubar(), ' '),
            ...this.options()
        }
    }

    options() {
        return {
            language: Lang.getLocale(),
            path_absolute : "/",
            content_css: this.contentCss(),
            autoresize_bottom_margin: 20,
            autoresize_min_height: 350,
            valid_children : "head[meta],td[span|br|img|strong|bold|italic]",
            style_formats: [
                { title: 'Paragraph with margins', selector: 'p', classes: 'new-paragraph' },
                { title: 'Paragraph no space', selector: 'p', styles: { 'margin-bottom': '0px', 'margin-top': '0px', 'padding-bottom': '0px', 'padding-top': '0px' } }
            ],
            image_class_list: [
                {title: 'Fixed size', value: 'img-fixed'},
                {title: 'Responsive', value: 'img-responsive'}
            ],
            fullpage_default_encoding: "UTF-8",
            fullpage_default_doctype: "<!DOCTYPE html>",
            relative_urls : false,
            remove_script_host : false,
            convert_urls : true,
            fix_list_elements: true,
            keep_styles: true,
            forced_root_block: 'p',
            templates: this.getTemplateSections(),
            end_container_on_empty_block: true,
            sticky_offset: 0,
            fontsize_formats : '8pt 10pt 11pt 12pt 14pt 16pt 18pt 24pt 36pt 48pt',
            font_formats: this.fontFormats(),
            branding: false,
            pagebreak_separator: "<div class=\"page-break-before\"><!-- page break --></div>",
            contextmenu: "bold underline italic strikethrough | image | inserttable cell row column deletetable",
            table_style_by_css: false,
            table_default_attributes: {
                border: 1,
                cellpadding: 5
            },
            table_default_styles: {
                width: '100%',
                border: '1px #000000 solid',
                'border-collapse': 'collapse',
            },
            file_browser_callback: (field_name, url, type, win) => {
                this.fileBrowserCallback(field_name, url, type, win)
            },
            setup: (editor) => {
                editor.addButton('saveTemplate', saveReusableSectionButton(editor));

                editor.on('init', event => {
                    this.addCustomPlugins(event)
                    checkEligibleArrayItems(event)
                });

                editor.on('ExecCommand', event => {
                    this.fixVariableFormattingIssue(event)
                    checkEligibleArrayItems(event)
                });

                editor.on('click', checkEligibleArrayItems);
                editor.on('keyup', checkEligibleArrayItems);

                function checkEligibleArrayItems(event) {
                    eventBus.$emit('checkEligibleArrayItems');
                }
            },
        }
    }

    /**
     * Foile de stil ale corpului editorului. Cea a fontului clientului se adauga numai pe
     * instantele care il au activat, si vine din Sincron, nu dintr-o cale scrisa aici.
     * TinyMCE 4 desparte valoarea pe virgula (Tools.explode).
     */
    contentCss() {
        const extra = (typeof Sincron !== 'undefined' && Array.isArray(Sincron.extraFontCss))
            ? Sincron.extraFontCss
            : []

        return ['/css/tinymce2.css'].concat(extra).join(',')
    }

    /**
     * Lista de fonturi a editorului: cele implicite ale TinyMCE plus familiile trimise de
     * Sincron pentru instanta curenta. Lista implicita se scrie explicit pentru ca
     * font_formats o INLOCUIESTE, nu o completeaza. Lista se ordoneaza alfabetic pe
     * eticheta, ca fontul clientului sa nu ajunga la coada.
     */
    fontFormats() {
        const defaults = 'Andale Mono=andale mono,monospace;'
            + 'Arial=arial,helvetica,sans-serif;'
            + 'Arial Black=arial black,sans-serif;'
            + 'Book Antiqua=book antiqua,palatino,serif;'
            + 'Comic Sans MS=comic sans ms,sans-serif;'
            + 'Courier New=courier new,courier,monospace;'
            + 'Georgia=georgia,palatino,serif;'
            + 'Helvetica=helvetica,arial,sans-serif;'
            + 'Impact=impact,sans-serif;'
            + 'Symbol=symbol;'
            + 'Tahoma=tahoma,arial,helvetica,sans-serif;'
            + 'Terminal=terminal,monaco,monospace;'
            + 'Times New Roman=times new roman,times,serif;'
            + 'Trebuchet MS=trebuchet ms,geneva,sans-serif;'
            + 'Verdana=verdana,geneva,sans-serif;'
            + 'Webdings=webdings;'
            + 'Wingdings=wingdings,zapf dingbats'

        const extra = (typeof Sincron !== 'undefined' && Array.isArray(Sincron.extraFonts))
            ? Sincron.extraFonts
            : []

        const intrari = defaults.split(';').filter(intrare => intrare)

        extra.forEach(font => {
            if (font && font.label && font.stack) {
                intrari.push(font.label + '=' + font.stack)
            }
        })

        const eticheta = intrare => intrare.split('=')[0].toLowerCase()

        // aceeasi colatie ca in Sincron (strcasecmp): comparatie pe coduri de caracter, nu
        // pe reguli de limba, ca cele doua editoare sa nu ordoneze diferit
        return intrari.sort((a, b) => {
            const x = eticheta(a)
            const y = eticheta(b)

            if (x < y) { return -1 }
            if (x > y) { return 1 }

            return 0
        }).join(';')
    }

    plugins() {
        return [
            'paste',
            'print',
            'preview',
            'fullpage',
            'searchreplace',
            'autoresize',
            'table',
            'lists',
            // 'autosave',
            'code',
            'template',
            'contextmenu',
            'image',
            // 'imagetools',
            'textcolor',
            'noneditable',
            'visualblocks',
            'code',
            'stickytoolbar',
            'pagebreak'
        ]
    }

    toolbar() {
        return [
            'undo redo',
            'formatselect',
            'fontselect fontsizeselect',
            'styleselect lineheight',
            'bold underline italic strikethrough forecolor backcolor removeformat',
            'alignleft aligncenter alignright alignjustify',
            'numlist bullist outdent indent',
            'template saveTemplate',
            'restoredraft',
            'image table',
            'pagebreak',
            'code',
        ]
    }

    menubar() {
        return [
            // 'file',
            // 'edit',
            // 'view',
            // 'insert',
            // 'format',
            // 'table',
            // 'tools'
        ]
    }

    addCustomPlugins() {
        this.stickyToolbarPlugin()
    }

    getTemplateSections() {
        return _.map(Sincron.templateSections, (section) => {
            return {
                title: section.name,
                content: section.body
            }
        })
    }


    fixVariableFormattingIssue(e) {
        var selection = tinyMCE.activeEditor.selection.getContent();
        var el = document.createElement( 'html' );
        el.innerHTML = "<head></head><body>"+selection+"</body>";
        var datapoints =  Array.from(el.getElementsByClassName('mceNonEditable'));
        if (datapoints.length>0) {
            var styleToggle = function(key, value) {
                var criteria = (datapoints.map(function(datapoint){
                    return (datapoint.style[key] == value);
                }).reduce(function(a,b) {
                    return a&&b;
                }));
                if (criteria) {
                    datapoints.forEach(function(datapoint){
                        datapoint.style[key] = "";
                        datapoint.contentEditable = false;
                    });
                } else {
                    datapoints.forEach(function(datapoint){
                        datapoint.style[key] = value;
                        datapoint.contentEditable = false;
                    });
                };
            }
            switch (e.command) {
                case 'mceToggleFormat':
                    switch (e.value) {
                        case 'bold':
                            styleToggle("font-weight", "bold");
                            break;
                        case 'italic':
                            styleToggle ("font-style", "italic");
                            break;
                        case 'strikethrough':
                            styleToggle ("text-decoration", "line-through");
                            break;
                        case 'underline':
                            styleToggle ("text-decoration", "underline");
                    };
                    tinyMCE.activeEditor.selection.setContent(el.children[1].innerHTML);
                    break;
                case ("mceApplyTextcolor"):
                    styleToggle ("color", e.value);
                    tinyMCE.activeEditor.selection.setContent(el.children[1].innerHTML);
                    break;
                case ("FontName"):
                    styleToggle ("font-family", e.value);
                    tinyMCE.activeEditor.selection.setContent(el.children[1].innerHTML);
                    break;
                case ("FontSize"):
                    styleToggle ("font-size", e.value);
                    tinyMCE.activeEditor.selection.setContent(el.children[1].innerHTML);
                    break;
                case ("RemoveFormat"):
                    datapoints.forEach(function(datapoint){
                        ["font-weight", "font-style", "text-decoration",
                            "text-decoration", "color", "font-family", "font-size"].forEach(function(key){
                            datapoint.style[key]="";
                        })
                        datapoint.contentEditable = false;
                    });
                    tinyMCE.activeEditor.selection.setContent(el.children[1].innerHTML);
                    break;
            };
        }
    }

    fileBrowserCallback(field_name, url, type, win) {
        let x = window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth;
        let y = window.innerHeight|| document.documentElement.clientHeight|| document.getElementsByTagName('body')[0].clientHeight;

        let cmsURL = this.options().path_absolute + 'laravel-filemanager?field_name=' + field_name;
        if (type === 'image') {
            cmsURL = cmsURL + "&type=Images";
        } else {
            cmsURL = cmsURL + "&type=Files";
        }

        cmsURL = cmsURL + "&token=" + Sincron.token

        tinyMCE.activeEditor.windowManager.open({
            file : cmsURL,
            title : 'Filemanager',
            width : x * 0.8,
            height : y * 0.8,
            resizable : "yes",
            close_previous : "no"
        });
    }

    stickyToolbarPlugin() {
        tinyMCE.PluginManager.add('stickytoolbar', function(editor, url) {
            editor.on('init', function() {
                setSticky();
            });

            $(window).on('scroll', function() {
                setSticky();
            });

            function setSticky() {
                var container = editor.editorContainer;
                var toolbars = $(container).find('.mce-toolbar-grp');
                var statusbar = $(container).find('.mce-statusbar');

                if (isSticky()) {
                    $(container).css({
                        paddingTop: toolbars.outerHeight()
                    });

                    if (isAtBottom()) {
                        toolbars.css({
                            top: 'auto',
                            bottom: statusbar.outerHeight(),
                            position: 'absolute',
                            width: '100%',
                            borderBottom: 'none'
                        });
                    } else {
                        toolbars.css({
                            top: 0,
                            bottom: 'auto',
                            position: 'fixed',
                            width: $(container).width(),
                            borderBottom: '1px solid rgba(0,0,0,0.2)'
                        });
                    }
                } else {
                    $(container).css({
                        paddingTop: 0
                    });

                    toolbars.css({
                        position: 'relative',
                        width: 'auto',
                        borderBottom: 'none'
                    });
                }
            }

            function isSticky() {
                var container = editor.editorContainer,
                    editorTop = container.getBoundingClientRect().top;

                if (editorTop < 0) {
                    return true;
                }

                return false;
            }

            function isAtBottom() {
                var container = editor.editorContainer,
                    editorTop = container.getBoundingClientRect().top;

                var toolbarHeight = $(container).find('.mce-toolbar-grp').outerHeight();
                var footerHeight = $(container).find('.mce-statusbar').outerHeight();

                var hiddenHeight = -($(container).outerHeight() - toolbarHeight - footerHeight);

                if (editorTop < hiddenHeight) {
                    return true;
                }

                return false;
            }
        });
    }

}
